import { useCallback } from "react";

/** Short locale-aware date + time for lists and chips. */
export function useFormatShortDateTime() {
  return useCallback((iso: string) => {
    const d = new Date(iso);
    return (
      d.toLocaleDateString(undefined, { month: "short", day: "numeric" }) +
      " " +
      d.toLocaleTimeString(undefined, { hour: "2-digit", minute: "2-digit" })
    );
  }, []);
}
